/**
 * @packageDocumentation
 * @module promises/timeout
 * @preferred
 */
/**
 * Creates a promise that is resolved after the given time (milliseconds).
 *
 * @param ms - number of milliseconds to wait.
 */
export const timeout = (ms) => new Promise((res) => {
    setTimeout(res, ms);
});
/**
 * Alias for [[timeout]]
 */
export const sleep = timeout;
/**
 * Alias for [[timeout]]
 */
export const sleepMillis = timeout;
/**
 * Alias for [[sleepMillis]] but with seconds instead of milliseconds.
 */
export const sleepSeconds = (seconds) => sleepMillis(seconds * 1000);
